import { CircleAIAppShell } from "@circle-react-uikit/CircleAIAppShell";
import type { PropsWithChildren } from "react";

import { CanvasHeader } from "./CanvasHeader";
import { CanvasInsetBody } from "./CanvasInsetBody";

interface CanvasInsetProps extends PropsWithChildren {
  /** Keep the canvas header visible even when the AI panel is closed. */
  alwaysShowHeader?: boolean;
}

/**
 * Canvas "double container": the canvas header above a tinted inset with a
 * rounded primary content card nested inside it. The header, tint, and card are
 * three parts of one surface, so they're bound together here — a call site
 * can't apply one without the others. Shared by the member and settings shells.
 *
 * `children` render inside the card; consumers that need a sub-header above the
 * body (e.g. the member shell's app header) place it first (see `CanvasInsetBody`).
 */
export const CanvasInset = ({
  alwaysShowHeader = false,
  children,
}: Readonly<CanvasInsetProps>) => (
  <CircleAIAppShell.Layout.Inset hasTintedBackground>
    <CanvasHeader alwaysVisible={alwaysShowHeader} />
    <CanvasInsetBody>{children}</CanvasInsetBody>
  </CircleAIAppShell.Layout.Inset>
);

CanvasInset.displayName = "CanvasInset";
